/**
 * Survey launcher factory for Web SDK
 */

import { Api } from "@ms-ofb/floodgate-shared-typings";
import { Utils } from "@ms-ofb/officefloodgatecore";
import * as Configuration from "../Configuration/Configuration";
import GenericMessagingLauncherFactory from "./GenericMessagingLauncherFactory";
import RudeSurveyLauncherFactory from "./RudeSurveyLauncherFactory";

const { isNOU } = Utils;

export default class AdaptiveSurveyLauncherFactory implements Api.ISurveyLauncherFactory {
	public static make(): Api.ISurveyLauncherFactory {
		return new AdaptiveSurveyLauncherFactory(
			new RudeSurveyLauncherFactory(),
			new GenericMessagingLauncherFactory());
	}

	private rudeSurveyLauncherFactory: RudeSurveyLauncherFactory;
	private genericMessagingLauncherFactory: GenericMessagingLauncherFactory;

	private constructor(rudeSurveyLauncherFactory: RudeSurveyLauncherFactory,
		genericMessagingLauncherFactory: GenericMessagingLauncherFactory) {
		this.rudeSurveyLauncherFactory = rudeSurveyLauncherFactory;
		this.genericMessagingLauncherFactory = genericMessagingLauncherFactory;
	}

	public makeSurveyLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
		if (isNOU(survey)) {
			return null;
		}

		switch (survey.getLauncherType().toLocaleLowerCase()) {
			case GenericMessagingLauncherFactory.COACHINGUX_LAUNCHER_TYPE:
			case GenericMessagingLauncherFactory.DIALOG_LAUNCHER_TYPE:
				return this.makeGenericMessagingSurfaceLauncher(survey);
			case RudeSurveyLauncherFactory.LAUNCHER_TYPE:
			default:
				return this.makeRudeSurveyLauncher(survey);
		}
	}

	public AcceptsSurvey(survey: Api.ISurvey): boolean {
		if (isNOU(survey)) {
			return false;
		}

		switch (survey.getType()) {
			case Api.SurveyType.Dialog:
			case Api.SurveyType.GenericMessagingSurface:
				return (Configuration.get().checkIfMessagingEnabled() &&
						!isNOU(this.genericMessagingLauncherFactory) &&
						this.genericMessagingLauncherFactory.AcceptsSurvey(survey));
			default:
				return Configuration.get().checkIfSurveysEnabled() &&
					!isNOU(this.rudeSurveyLauncherFactory) &&
					this.rudeSurveyLauncherFactory.AcceptsSurvey(survey);
		}
	}

	private makeGenericMessagingSurfaceLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
		if (!isNOU(this.genericMessagingLauncherFactory)) {
			return this.genericMessagingLauncherFactory.makeSurveyLauncher(survey);
		}

		return null;
	}

	private makeRudeSurveyLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
		if (!isNOU(this.rudeSurveyLauncherFactory)) {
			return this.rudeSurveyLauncherFactory.makeSurveyLauncher(survey);
		}

		return null;
	}
}
